export default {
  transactionHistoryData: [],
  tradeHistoryData: [],
  orderHistoryData: [],
};